module.exports = __webpack_public_path__ + "bs.svg?f88e2401ba07315101ea050e284a2cfc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bs.svg
// module id = 765
// module chunks = 27